
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../services/timesheetreportsService';
import {timesheetService} from '../services/timesheetService';
import {timesheetuserService} from '../services/timesheetUserservice';
import {formatterhelper} from '../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaArrowDown,FaArrowCircleDown } from "react-icons/fa";
import Smallloader from '../compnents/loader';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Message } from 'primereact/message';
import {Mandate} from '../compnents/formcomp';
import { calculatepercent } from '../helpers/calculatepercent';

const MultiApprover = () => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        fromdate: '',
        employee: '',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [rdsdataavail,setrdsDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [allsubclients,setallsubClients] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [isrdsloaded,setrdsloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [isverified,setverification] = useState(true);
    const [tmslists,settmslists] = useState([]);
    const [remainhrsloaded, setremainhrsloaded] = useState(true);
    const permissionsvalue__ = localStorage.getItem('permissions') != '' ? JSON.parse(localStorage.getItem('permissions')) : {};
    const [selectedobj,setselectedobj] = useState({});
    const [remainloaded,setreminloader] = useState(true);
    const [isreworktoggle,setreworktoggle] = useState(false);
    const [minutestcount,setminutescount] = useState({minutes:0,count:0});
    const [ischanged,setChangeddata] = useState('ischanged');
    const [iseditable,setallowEdit] = useState(false);
    const [billedminutes, setBilledminutes] = useState(0);
    const [percentage, setPercentage] = useState('');
    const [percentval, setPercentval] = useState('');
    const [selectedclient, setSelectedClient] = useState('');
    const [selectedtask, setSelectedTask] = useState('');
    const [tasks, setTasks] = useState([]);
    const [selectedsubclient, setSelectedsubclientt] = useState('');
    const [checkall, setCheckall] = useState([]);
    const [filteredobj, setfilterObject] = useState({});
   

    const [reworkform, setReworkform] = useState({
        timesheetid:'',
        minutes:0,
    }); 
     
    const [formData2, setForm2Data] = useState({
        recordid:'',
        client: '',
        subclient: '',
        subclientid: '',
        task:'',
        Minutes:'',
        BilledMinutes:'',
        budgethours:'',
        remainingbudgethours:'',
        Count:'',
        date:'',
        fillingfor:'',
        Remarks:'',
        querycount:'',
        remarks:''
      });
     
    useEffect(()=>{
        getuserslist();
        _getallclient();
        _gettasks();
    },[]);

    useEffect(()=>{
        counterfunction();
    },[tmslists]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));

        if(name == 'date'){
            // if(formData.employee == ''){
            //      return;
            // }
            let objdata = {
                'date':formatterhelper.dateformatter({date:value}),
                'userid':formData.employee
            };
            setfilterObject((prevData) =>{
                return {
                    ...prevData,
                   'date':formatterhelper.dateformatter({date:value}),
                }
            });    

            // gettimesheetapproval(objdata);
            // rdsshowreporttoappr(objdata);
            setselectedobj(objdata);
            setChangeddata('datechanged');
        }

        if(name == 'employee'){
             let objdata = {
                 'date':formatterhelper.dateformatter({date:formData.fromdate}),
                 'userid':value
             };

             if(value == ''){
                toast.current.show({ severity: 'error', summary: 'Approver', detail: 'Employee field is required', life: 3000 });  
                return;    
             }

             setfilterObject((prevData) =>{
                 return {
                     ...prevData,
                     'userid':value
                 }
             });
             
            //  gettimesheetapproval(objdata);
            //  rdsshowreporttoappr(objdata);
             setselectedobj(objdata);
             setChangeddata('empchanged');
        }


        
        // gettimesheetapproval(filteredobj);
        
    };

    useEffect(()=>{
        console.log(filteredobj);
        if((filteredobj.userid != undefined && filteredobj.userid != '')){
            if((filteredobj.date != undefined && filteredobj.date != '')){
                gettimesheetapproval(filteredobj);  
            }
                 
        } 
    },[filteredobj]);

    const handleSubmit = (e) => {
        e.preventDefault();
        let reportobj = {
          'tsdate':formatterhelper.dateformatter({date:formData.date}),
          'userid':formData.employee
        };
       
        // console.log(reportobj);
        // approve_tms({obj:reportobj});
        approvalconfirm({obj:reportobj});
        // Now you can perform any further actions with the form data
     };


    function approvalconfirm({obj}){
        console.log('report object'); 
        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept: () => approve_tms({obj}),
           //  accept,
            reject
        });
    }

    const reject = () => {
      toast.current.show({ severity: 'warn', summary: 'Timesheet', detail: 'Canceled', life: 3000 });
    }

     function approve_tms({obj}){
        try{
            timesheetService.approve_all({obj}).then((response)=>{
                if(response.status == 200){
                    if(response.data.isverfied == 'Verified'){
                        setverification(true);
                    }else{
                        setverification(false);
                    }
                    gettimesheetapproval(filteredobj);  
                    settmslists(response.data.data);  
                    
                    toast.current.show({ severity: 'success', summary: 'Timesheet', detail: 'Approved Successfully', life: 3000 });  
                 }else{
                    setverification(true);
                    settmslists([]);
                } 
            }).catch((error)=>{
                console.log(error);  
                setverification(true);
                settmslists([]);      
            });
        }catch(error){
           console.log(error);
        }
     }

     function counterfunction(){
        let totalmin = 0;
        let count = 0;

        console.log('counter function changed');
        
        if(tmslists != undefined){
           console.log("counter function data lits");
           console.log(tmslists,"timesshet lists");
           tmslists.forEach((values)=>{
              totalmin = (typeof values.workhrs === 'number' ? values.workhrs : 0) + totalmin;
              count = (typeof values.rcnt === 'number' ? values.rcnt : 0)  + count;
           });

           // settimesheetliststemp(data);
           if(tmslists.length <= 0 ){
              setminutescount({minutes:0,count:0});
           }else{
              setminutescount({minutes:totalmin,count:count});
           }
        }
      }

     const handleChangetimesheet = (e) => {
        const { name, value } = e.target;
        setForm2Data((prevData) => ({
          ...prevData,
          [name]: value,
        }));

        if(name == 'client'){
            let selected_client = e.target.value;
            setForm2Data((prevData) => ({...prevData,client:selected_client})); 
            getallsubclients({client:selected_client}); 
            setSelectedClient(selected_client);
            if(shouldcalculate(selectedtask)){
                getPercentage(selected_client);      
             }else{
                filterdata(tasks,selectedtask);
             }
        }

        if(name == 'subclient'){
            let subclientobj = allsubclients[e.target.selectedIndex - 1];
            console.log(subclientobj);
            setForm2Data((prevData) => {
                return {
                    ...prevData,
                    subclientid:subclientobj.id
                } 
            });

            setSelectedsubclientt(value);
            getremaining_hrs({clientid:formData2.client,subclientid:value,ftype:'edit'}); 
        }

        if(name == 'BilledMinutes'){
            console.log(value);
            setBilledminutes(value);
            let percent = calculatepercent(value,percentage);
            setPercentval(percent);
        }
        
         if(name == 'task'){
            setSelectedTask(value);
            filterdata(tasks,value);
         }
     };

     function shouldcalculate(task){
        if(task == '' || task == undefined){
            return true;
        }else{
            return false;
        }
     }

     
     useEffect(()=>{
        filterdata(tasks,selectedtask);  
     },[selectedsubclient])

     const filterdata = (tasks = [],value) =>{
        let isexeute = false;
        // console.log("tasks");
        // console.log(tasks);
        if (tasks && Array.isArray(tasks)) {
            const found = tasks.some((innerval) => {

                if ((innerval.id == value && innerval.name == "External Amendment") || 
                    (innerval.id == value && innerval.name == "Personal Tax return") || (innerval.id == value && innerval.name == 'Service charge accounts' || selectedsubclient == 'Admin Hours' || selectedsubclient == 'Admin') || (innerval.id == value && innerval.name == "Service Charge Accounts") ||
                    (innerval.id == value && innerval.name == "Management Accounts")) {
                    
                    let percent = calculatepercent(billedminutes, 100);
                    setPercentval(percent);
                    setPercentage(100); 
                    isexeute = false;
                    return true;  // Stop the loop early
                }
                return false;
            });
            
            if (!found) {
                isexeute = true;
            }
      
            if(isexeute){
               getPercentage(selectedclient,{value:billedminutes});
            }
        }
        
     }

    const handleSubmittimesheet = (e) => {
        e.preventDefault();
        console.log('form data2');
        let objdata = {"recordid":formData2.recordid,
        "tasklstid":formData2.task,
        "Minutes":formData2.Minutes,
        "BilledMinutes":formData2.BilledMinutes,
        "Count":formData2.Count,
        "querycount":formData2.querycount,
        "Remarks":formData2.Remarks,
        "client":formData2.client,
        "subclient":formData2.subclient,
        "subclientid":formData2.subclientid    
    }; 

        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept: () => updatedtimesheet({obj:objdata}),
           //  accept,
            reject
        });
    };  

    function updatedtimesheet({obj}){
    //   console.log("update timesheet");   
    //   console.log(selectedobj);  

      obj['qapercentage'] = percentage;
      obj['qapercentval'] = percentval;

      timesheetService.approver_edited_tms({obj}).then((response)=>{
          console.log("update timesheet");
          console.log(response);
          if(response.status == 200){
               toast.current.show({ severity: 'success', summary: 'Timesheet', detail: 'Updated successfully', life: 3000 });
               let objdata = {
                'date':formatterhelper.dateformatter({date:formData.fromdate}),
                'userid':formData.employee
                };
                console.log(objdata,'object data');
                console.log(selectedobj,'selceted obj');
               gettimesheetapproval(objdata);
               settoggle(false);
          }else{
            toast.current.show({ severity: 'error', summary: 'Timesheet', detail: 'Not Updated', life: 3000 });
          }
      }).catch((error)=>{
          toast.current.show({ severity: 'error', summary: 'Timesheet', detail: 'Not Updated', life: 3000 });
          console.log(error);
      });
    }

    function _getallclient(){
    let emparr = [];
    timesheetService.getallclient().then((response)=>{
        // setClients(response.data.data);
        response.data.data.forEach((value,index)=>{
            if(value.client != ''){
                emparr.push((<option key={index} value={value.client}>{value.client}</option>));
            }
        });
        setClientscomp(emparr);
    }).catch((error)=>{
        console.log(error);  
    }); 
    }

    function getallsubclients({client}){
        let emparr = [];
        setSubclientloader((<Smallloader/>));

        return timesheetService.getallsubclienttemp({client:client}).then((response)=>{
            if(response == undefined || response == '' || response.data.data == undefined){
                  return;
            }
            if(response.status == 201){
                console.log("subcleint comp");
                setsubClientscomp([]);
                setSubclientloader((<></>));
                setreminloader(true);
                return;     
            }
            // console.log('response subclient');
            // console.log(response);
            response.data.data.forEach((value,index)=>{
               emparr.push((<option key={index} id={value.id} value={value.subclient}>{value.subclient}</option>)); 
            });
            
            setsubClientscomp(emparr);
            setSubclientloader((<></>));
            setallsubClients(response.data.data);
            setreminloader(true);
            return response.data.data;
         }).catch((error)=>{
            console.log(error);  
            setSubclientloader((<></>));
            setreminloader(true);
         }); 


        timesheetService.getallsubclient({client:client}).then((response)=>{
           console.log('response subclient');
           console.log(response);
           //  setClients(response.data.data);
            response.data.data.forEach((value,index)=>{
              emparr.push((<option key={index} value={value.subclient}>{value.subclient}</option>)); 
            });
            setsubClientscomp(emparr);
            setSubclientloader((<></>));
        }).catch((error)=>{
           console.log(error);  
           setSubclientloader((<></>));
        }); 
     }
    
    function getuserslist(){
        let emparr = [];
        timesheetuserService.getuserlistbyapprover().then((response) =>{
           console.log(response.data.data);
           response.data.data.forEach((value,index)=>{
            emparr.push(<option value={value.id}>{value.name}</option>);
           });  
           setempcomp(emparr);
        }).catch((error)=>{
           console.log(error);
        });   
    }

    // useEffect(()=>{
            
    // },[addtimesheettoggle])

    function gettimesheetapproval(obj){
       try{
            setDatastate(false);
            setloading(false);
            setselectedobj(obj);
            let emparr = [];
            timesheetreportService.getmultitimesheeforapproval({obj:obj}).then((response)=>{
                // console.log('response approval data'); 
                // console.log(response.data.data);
                // console.log(response.data.isverfied); 
                if(response.status == 200){
                    if(response.data.isverfied == 'Verified'){
                        setverification(true);
                    }else{
                        setverification(false);
                    }
                    settmslists(response.data.data);
                    response.data.data.forEach((value,index)=>{
                        emparr.push((<tr>
                            <td scope="col"><input type="checkbox"/></td>
                            <td scope="col">{value.ts_id}</td>
                            <td scope="col">{value.clientname}</td>
                            <td scope="col">{value.subclientname}</td>
                            <td scope="col">{value.ts_date}</td>
                            <td scope="col">{value.taskname}</td>
                            <td scope="col">{value.workhrs}</td>
                            <td scope="col">{value.billedworkhrs}</td>
                            <td scope="col">{value.querycount}</td>
                            <td scope="col">{value.remarks}</td>
                            <td scope="col">{(value.ts_status == null)  ? <FaEdit className='custom-cursor-style' onClick={()=>{editobjdatafun(value);settoggle(true);}}/> : value.ts_status}</td>
                            <td scope="col">Rework</td>
                        </tr>)); 
                    });
                    setDatacomp(emparr);
                    setDatastate(true);
                    setloading(true);

                }else{
                    setDatacomp([]);
                    setDatastate(false);
                    setloading(true);
                    settmslists([]);
                }
            }).catch((error)=>{
                setDatastate(true);
                setloading(true);
                setDatacomp([]);
                settmslists([]);
            });
        }catch(error){
        //   console.log(error);
        }
        
    }

    function showstatusbox(status){
    //     console.log('status');
    //    console.log(status);
        if(status == 'Verified'){
            return (<>
                 <span className='approved-style' style={{padding:'4px 7px',borderRadius:'20px'}}>Verfied</span>
             </>);  
        }else{
             return (<></>);
        }
    }
    
    var arr = [];
    function checkdata(e,index,date){
       console.log(e.target.checked);
       if(e.target.checked){
           arr[index] = true; 
        //    arr.push(date);
       }else{
           arr[index] = false;
        // arr = arr.filter(item => item !== date); 
       }
    //    console.log(arr);
       setCheckall((prevData) => {
        return {
            ...prevData,
            ...arr  // Merging `arr` into the new object (make sure arr is an object)
        };
       });
    //   console.log(checkall);
    //    console.log(arr);  
    }

    function displayapprovedtms(){
        let emparr = [];
        tmslists.forEach((value,index)=>{
            // checkall[index] = false; 
           emparr.push((<tr>
                <td scope="col">
                 {/* {value.ts_status == null ? <input type="checkbox" checked={checkall[index]} onChange={(e) => checkdata(e,index,value.ts_date)}/> : ''} */}
                    
                </td>
                <td scope="col">{value.ts_id}</td>
                <td scope="col">{value.clientname}</td>
                <td scope="col">{value.subclientname}</td>
                <td scope="col">{value.ts_date}</td>
                <td scope="col">{value.taskname}</td>
                <td scope="col">{value.workhrs}</td>
                <td scope="col">{value.billedworkhrs}</td>
                <td scope="col">{value.rcnt}</td>
                {userdata.project == 'Bookkeeping' ? (<td scope="col">{value.querycount}</td>) : (<></>)}
                <td scope="col">{value.remarks}</td>
                <td scope="col">{value.ts_status == null ? '' : showstatusbox(value.ts_status) }</td>
                {/* {userdata.project == 'Bookkeeping' ? (<td scope="col"><FaEdit onClick={() => {setreworktoggle(true);setReworkform({timesheetid:value.ts_id})}} className="edit-btn-style custom-cursor-style" /></td>) : (<></>)} */}
                {/* <td scope="col">{value.qapercent}</td> */}
                
            </tr>)); 
        });
       return emparr; 
    }

    

    function _gettasks(){
        let emparr = [];
        timesheetService.gettasks().then((response) =>{
           console.log(response); 
           console.log('response get tasks');  
           if(response.status == 200){
                setTasks(response.data.data);
                response.data.data.forEach((value,index)=>{
                    emparr.push((<option value={value.id}>{value.name}</option>));
                });
               settaskscomp(emparr); 
           }
        }).catch((error) => {
             console.log(error);  
        });     
    }

    const getPercentage = (client,{value} = {}) => {
        timesheetService.getparticularpercentage(client).then((response) => {
           if (response.status == 200) {
              // if(value != undefined){
                 let percent = calculatepercent(value,response.data.data.percentage);
                 setPercentval(percent);
                 setPercentage(response.data.data.percentage);    
              // }
           } else {
              setPercentage('');
           }
        }).catch((error) => {
           setPercentage();
        })
     }

    const editobjdatafun = (obj) =>{
       
       setSelectedClient(obj.clientname);
    //    console.log(obj.billedworkhrs);
       setBilledminutes(obj.billedworkhrs);
       setPercentval(obj.qapercentval);
       setPercentage(obj.qapercent);

       console.log('obj data edit ');
    //    console.log(obj);
       getPercentage(obj.clientname,{value:obj.billedworkhrs}); 
       if(cleintscomp.length > 0){
        getallsubclients({client:obj.clientname});
        setForm2Data({recordid:obj.ts_id,client:obj.clientname,subclient:obj.subclientname,Minutes:obj.workhrs,
            Remarks:obj.remarks,budgethours:obj.budgetedhrs,
            BilledMinutes:obj.billedworkhrs,Count:obj.rcnt,querycount:obj.querycount,remainingbudgethours:'',task:obj.tasklstid,subclientid:obj.subclientid});     
        getremaining_hrs({clientid:obj.clientname,subclientid:obj.subclientname,ftype:'edit'});        
       }
    }

    const getremaining_hrs = ({clientid,subclientid,ftype}) =>{
        // console.log("cleint id");
        // console.log(clientid);
        setremainhrsloaded(false);
        if(ftype == 'add'){
            setForm2Data((prevData)=>({
            ...prevData,
            budgethours: '',
            remainingbudgethours:''     
          }));
        }else{
          setForm2Data((prevData)=>({
            ...prevData,
            budgethours: '0',
            remainingbudgethours:'NULL'     
          })); 
        }
        setreminloader(false);
       
        timesheetService.getremaining_hrs({clientid,subclientid}).then((response)=>{
         let budget_hours = response.data.budget_hours;
         let remaining_hours = response.data.remaining_hours;
   
         if(ftype == 'add'){
            setForm2Data((prevData)=>({
               ...prevData,
               budgethours: budget_hours,
               remainingbudgethours:remaining_hours     
             }));
         }else{
            setForm2Data((prevData)=>({
             ...prevData,
             budgethours: budget_hours,
             remainingbudgethours:remaining_hours    
           })); 
         }
         setreminloader(true);
         setremainhrsloaded(true);
        }).catch((error)=>{
           console.log(error);  
           setremainhrsloaded(true); 
           setreminloader(true);
        }) 
    }

    


     const qapercent = () =>{
        let obj = {
            'column': (<th>QA %</th>),
            'value': (<td>0</td>)   
         };

        return userdata.project_name == 'Year End' ? obj : {};    
     }

     function percentvalchange(e){
        console.log("percentage change"); 
        //console.log(e.target.value);
        if(billedminutes != ''){
            console.log("billed minutes");
            console.log(billedminutes);
            let value = e.target.value; 
            let percentage = ((value/billedminutes) * 100).toFixed(2);
            if(percentage <= 100){
               setPercentage(percentage); 
               setPercentval(e.target.value);    
            }
        }
   }

     function displaypercentage(percent) {
        return (
           userdata.project == 'Year End' ?
              (<div className='col-md-6'>
                 <br/> 
                 <label>QA Percentage</label>
                 <br />
                 <br />
                 <b>Percent : {percentage} %</b>
                 &nbsp;
                 <span><input type="text" value={percentval} onChange={percentvalchange} placeholder='value' className='form-control'/></span>
                 {/* <span>| Value : {percent}</span>    */}
              </div>) : '');
     }


    return (
        <>
            <div className="invisible-divider-sm"></div>
            <h6 class="card-style-padding-two">Multi Approver</h6>
            <Toast ref={toast} />
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-3">
                        <label className='pull-left'>Select Month</label>
                        <Calendar view="month" value={formData.date} name="date" onChange={handleChange} className='calender-custom-style' />
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Select User</label>
                        <select className='form-control' required name="employee" value={formData.employee} onChange={handleChange}>
                            <option value="">Select Employee</option> 
                            {empcomp}
                        </select>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Verify All Timesheet" severity="success" rounded className='custom-btn-style' />
                        </div>

                    </div>

                    <div className='col-md-4' style={{aligncontent: 'end'}}>
                        <div className='pagination-style'>Total Minutes : {minutestcount.minutes} | Count : {minutestcount.count}</div>
                    </div>
                </div>
                </form>
            </div>

            {/* Rework dialog */}
            {/* <Dialog header="Rework Minute Update" visible={isreworktoggle} style={{ width: '30vw' }} onHide={() => setreworktoggle(false)}>
               <form onSubmit={reworkSubmit}>
               <div className='col-md-12'>
                   <br/>
                  <div className='row'>
                     <div className='col-md-3'>
                     <label>Rework minute</label>
                     <input type='number' value={reworkform.minutes} class="form-control" onChange={(e) => setReworkform((prevData) => ({...prevData,minutes:e.target.value}))}/>  
                     </div>
                  </div> 
                  <br/>

                  <div className='row'>
                    <div> 
                      <div className='pull-right'>
                          <span>
                          <Button type="submit" label="Save" severity="success" rounded /> 
                          </span>

                          <span>
                          <Button type="button" label="Close" severity="danger" rounded  onClick={() => setreworktoggle(false)}/> 
                          </span>
                      </div>
                    </div>
                  </div>    
               </div>
              </form>
            </Dialog> */}
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
                {/* <Dialog header="Edit Timesheet" visible={addtimesheettoggle} style={{ width: '60vw' }} onHide={() => settoggle(false)}>
               <form onSubmit={handleSubmittimesheet}>
               <div className='col-md-12'>
                 <div className='row'>
                      <div className='col-md-12'>
                          {!remainloaded ? (<span className='pull-right'>{Smallloader()}</span>) : (remainconditioncomp().message)}
                        
                        
                          <br/><br/>
                         
                      </div>
                  </div>
                 <div className='row'>
                     <div className='col-md-6'>
                        <label><Mandate/> Select Client </label>  
                        <select className='custom-dropdown-style' required name="client" value={formData2.client} class="form-control" onChange={(e) => handleChangetimesheet(e)}>
                           <option value="">Select</option>
                           {cleintscomp}
                        </select>
                     </div>
                     <div className='col-md-6'>
                        <label><Mandate/> Select SubClient </label>
                        <span>{subclientLoader}</span> 
                        <select className='custom-dropdown-style' required name="subclient" value={formData2.subclient} class="form-control" onChange={(e) => handleChangetimesheet(e)}>
                           <option  value="">Select</option>
                           {subclientscomp}
                        </select>
                         
                     </div>
                  </div> 
                  <br/>  

                  <div className='row'>  
                     <div className='col-md-6'>
                        <label><Mandate/> Task</label>  
                        <select className='custom-dropdown-style' required name="task" value={formData2.task} class="form-control" onChange={(e) => handleChangetimesheet(e)}>
                           <option value="">Select</option>
                           {subtaskscomp}
                        </select> 
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/> Minutes</label>  
                        <input type='number' name='Minutes' required value={formData2.Minutes}  class="form-control" onChange={(e) => handleChangetimesheet(e)}/>
                     </div>
                     <div className='col-md-3'>
                        <label>Chargeable Minutes</label>
                        {remainconditioncomp().component}
                       
                     </div>
                  </div>   
                  <br/>
                  <div className='row'>
                     {remainconditioncomp().budgethourscomp}
                   
                      {remainconditioncomp().remainhourscomp}
                   
                    
                     <div className='col-md-3'>
                     <label>Count</label>
                     <input type='text' name='Count' value={formData2.Count} class="form-control" onChange={(e) => handleChangetimesheet(e)}/>  
                     </div>

                     {querycountcomp().edit}    
                     

                     <div className='col-md-6'>
                     <label><Mandate/> Remarks</label>
                     <br/>
                     <textarea type='text' name='Remarks' required value={formData2.Remarks} class="form-control" onChange={(e) => handleChangetimesheet(e)}/>  
                     </div>
                     <div className='col-md-3' style={{visibility:'hidden'}}>
                     <label><Mandate/> Filling For</label>
                     <select className='custom-dropdown-style' required name='date' value={formData2.date} class="form-control" onChange={(e) => handleChangetimesheet(e)}>
                           <option value="0">Today</option>
                           <option value="1">Yesturday</option>
                        </select> 
                     </div>

                     {displaypercentage(percentval)} 

                  </div> 
                  <br/>

                  <div className='row'>
                    <div> 
                      <div className='pull-right'>
                          <span>
                          <Button type="submit" label="Save" severity="success" rounded /> 
                          </span>

                          <span>
                          <Button type="button" label="Close" severity="danger" rounded onClick={()=>settoggle(false)} /> 
                          </span>
                      </div>
                    </div>
                  </div>    
               </div>
              </form>
                </Dialog> */}

                <ConfirmDialog />
               
                <div className='row'>
                <div className='col-md-12'> 
                    {!isloaded ? loader.Loadermd() : dataavail ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                 
                                <th scope="col"></th>
                                <th scope="col">Id</th>
                                <th scope="col">Client name</th>
                                <th scope="col">Subclient name</th>
                                <th scope="col">Date</th>
                                <th scope="col">Task name</th>
                                <th scope="col">Worked Minutes</th>
                                <th scope="col">Billing Minutes</th>
                                <th scope="col">Count</th>
                                {userdata.project == 'Bookkeeping' ? (<th scope="col">Query Count</th>) : (<></>)}
                                
                                <th scope="col">Remark</th>
                                <th scope="col">Status</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {displayapprovedtms()}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                </div>
                <br/> 
                {/* {rdsdataavail ? (<h3 className='text-style'><div className='section-label-style'>RDS Report &nbsp;&nbsp; <FaArrowCircleDown/></div></h3>) : (<h3 className='text-style'><div className='section-label-style'>RDS Report&nbsp;&nbsp; &nbsp;<FaArrowCircleDown/></div></h3>)}  */}

                {/* {rdsdataavail ? (<h3 className='text-style'><div className='section-label-style'>RDS Report &nbsp;&nbsp; <FaArrowDown/></div></h3>) : (<h3 className='text-style'><div className='section-label-style'>RDS Report&nbsp;&nbsp; &nbsp;<FaArrowDown/></div></h3>)} 
                
                <br/>                
                <div className='row'>
                    <div className='col-md-12'> 
                    {!isloaded ? loader.Loadermd() : rdsdataavail ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Employee Name</th>
                                <th scope="col">Date</th>
                                <th scope="col">Log in time</th>
                                <th scope="col">Log off time</th>
                                <th scope="col">Work</th>
                                <th scope="col">Break</th>
                                <th scope="col">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rdsdatacomp}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                </div> */}
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default MultiApprover;
